import SimCardDownloadOutlinedIcon from '@mui/icons-material/SimCardDownloadOutlined';
import {
  Box,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import moment from 'moment';
import React from 'react';

import { formatDueDate, getDueDate } from '@/Billing/dueDateUtils';
import NoRows from '@/components/tableNoRows';

import { IUnitBill } from '../View';

export const BillHistoryTable = ({
  data,
  timeZone,
}: {
  data: IUnitBill[];
  timeZone: string;
}): JSX.Element => {
  dayjs.extend(utc);
  dayjs.extend(timezone);
  const [tz] = React.useState(timeZone === '' ? moment.tz.guess() : timeZone);

  const renderStatusColor = (status: string): string => {
    switch (status) {
      case 'not_created':
        return '#E0E0E0';
      case 'draft':
        return '#D0E9FF';
      case 'open':
        return '#FFEFD0';
      case 'paid':
        return '#DFF7DF';
      case 'uncollectable':
        return '#FFD6D6';
      case 'void':
        return '#E4D6FF';
      default:
        return '#E0E0E0';
    }
  };

  return (
    <div>
      <TableContainer component={Paper} sx={{ mt: 3 }}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              <TableCell align="center" sx={{ position: 'relative' }}>
                Amount
              </TableCell>
              <TableCell align="center" sx={{ position: 'relative' }}>
                Due
              </TableCell>
              {/* <TableCell align="center" sx={{ position: 'relative' }}>
                Email
              </TableCell> */}
              <TableCell align="center" sx={{ position: 'relative' }}>
                Billing Period
              </TableCell>
              <TableCell align="center" sx={{ position: 'relative' }}>
                Status
              </TableCell>
              <TableCell align="center" sx={{ position: 'relative' }}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length !== 0 ? (
              data.map((e, _i) => {
                return e.invoices.map((d) => {
                  return (
                    <TableRow>
                      <TableCell align="center">
                        {d.stripeTotal !== null ? `$${d.stripeTotal}` : '-'}
                      </TableCell>
                      <TableCell align="center">
                        {(() => {
                          // Stored custom-invoice due date wins; the 21-day
                          // calculation is only a fallback for Stripe invoices,
                          // which carry no stored due date on this shape
                          const dueDate = getDueDate(
                            d.customInvoiceDueDate,
                            e.billsSentTimestamp ? e.billsSentTimestamp : e.endDate,
                            21,
                            timeZone,
                          );
                          return dueDate !== null ? formatDueDate(dueDate, timeZone) : '-';
                        })()}
                      </TableCell>
                      {/* <TableCell align="center">some@email.com</TableCell> */}
                      <TableCell align="center">
                        {dayjs.unix(e.startDate).tz(tz).format('MMM D')} -{' '}
                        {dayjs.unix(e.endDate).tz(tz).format('MMM D')}
                      </TableCell>
                      <TableCell align="center">
                        <Box
                          sx={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: renderStatusColor(d.stripeLastStatus),
                            color: d.stripeLastStatus === 'paid' ? '#198754' : '#5A5A5A',
                            borderRadius: '16px',
                            fontWeight: 'bold',
                            padding: '4px 12px',
                            fontSize: '0.875rem',
                            textTransform: 'uppercase',
                            boxShadow: 1,
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {d.stripeLastStatus.replace('_', ' ').toUpperCase()}
                        </Box>
                      </TableCell>
                      <TableCell align="center">
                        <IconButton
                          disabled={
                            d.customInvoicePdfUrl === null && d.stripeInvoicePdfUrl === null
                          }
                          onClick={() =>
                            (window.location.href = (d.customInvoicePdfUrl ??
                              d.stripeInvoicePdfUrl)!)
                          }
                        >
                          <SimCardDownloadOutlinedIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                });
              })
            ) : (
              <TableRow>
                <TableCell colSpan={6} sx={{ marginTop: 2 }}>
                  <NoRows title="No Rows" />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
